/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Delete_ConfirmInputs */

const cs_blog_delete_confirm = /** @type {(inputs: Blog_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trvale smazat tento článek?`)
};

const en_blog_delete_confirm = /** @type {(inputs: Blog_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this article permanently?`)
};

/**
* | output |
* | --- |
* | "Delete this article permanently?" |
*
* @param {Blog_Delete_ConfirmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_delete_confirm = /** @type {((inputs?: Blog_Delete_ConfirmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Delete_ConfirmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_delete_confirm(inputs)
	return cs_blog_delete_confirm(inputs)
});